import { motion } from "framer-motion";
import { headingVariants, fadeInVariants, viewportSettings } from "../../shared/utils/animations";
import styles from "./classes.module.scss";

const Classes = () => {
  const MASTERCLASS_URL = "https://abundanceextensions.com/products/masterclass-ticket-abundance-extensions";

  return (
    <div className={styles["classes-container"]}>
      <div className={styles["content-wrapper"]}>
        <motion.div
          initial="headingOffScreen"
          whileInView="headingOnScreen"
          viewport={viewportSettings}
          variants={headingVariants}
        >
          <h1>Master Class</h1>
          <h2>Abundance Extensions</h2>
        </motion.div>
        
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p className={styles["subtitle"]}>
            Elevate your artistry with an exclusive hands-on workshop
          </p>
        </motion.div>

        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p className={styles["description"]}>
            Join us for an intimate, hands-on extensions masterclass designed for stylists ready to elevate their craft and expand their service offerings with confidence. Hosted at Meraki Lounge Salon in Downtown San Diego, this immersive experience focuses on seamless installs, flawless blending, and refined technique.
          </p>
        </motion.div>

        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <div className={styles["features-section"]}>
            <h3>What's Included</h3>
            <div className={styles["features-list"]}>
              <div className={styles["feature-item"]}>
                <span className={styles["check-icon"]}>✓</span>
                <span>Professional extension kit included</span>
              </div>
              <div className={styles["feature-item"]}>
                <span className={styles["check-icon"]}>✓</span>
                <span>Intimate class size for personal attention</span>
              </div>
              <div className={styles["feature-item"]}>
                <span className={styles["check-icon"]}>✓</span>
                <span>Certificate of completion</span>
              </div>
              <div className={styles["feature-item"]}>
                <span className={styles["check-icon"]}>✓</span>
                <span>Lifetime access to exclusive community</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <button
            className={styles["cta-button"]}
            onClick={() => {
              window.open(MASTERCLASS_URL, "_blank");
            }}
          >
            Reserve Your Spot
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default Classes
